import React from 'react';
import { Box, ListItemAvatar, Typography } from '@mui/material';
import newLogo from '../../assets/images/LogoWhite.png';

/**
 * LeftPanelHeader - Header component for the left panel with logo and brand name
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isDrawerExpanded - Whether the drawer is expanded
 * @param {boolean} props.isHovering - Whether the mouse is hovering over the drawer
 * @returns {JSX.Element} Rendered header component
 */
const LeftPanelHeader = React.memo(({ isDrawerExpanded, isHovering }) => {
  return (
    <Box
      className='flexBox flexCenter'
      sx={{
        m: isDrawerExpanded || isHovering ? 1 : 1,
        position: 'sticky',
        top: 0,
        zIndex: 1200,
        backgroundColor: 'var(--clr-mindly-background)',
      }}
    >
      <ListItemAvatar
        sx={{
          display: { xs: 'flex', md: 'flex' },
          mx: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            backgroundColor: 'var(--clr-theme-purple)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            width: '3rem',
            height: '3rem',
            overflow: 'hidden',
          }}
        >
          <img
            src={newLogo}
            alt='mindly'
            style={{
              maxWidth: '72%',
              maxHeight: '72%',
              objectFit: 'contain',
            }}
          />
        </div>
      </ListItemAvatar>
      {(isDrawerExpanded || isHovering) && (
        <Typography
          className='brand'
          variant='caption'
          noWrap
          sx={{
            display: { md: 'flex' },
            fontSize: '2rem !important',
            fontFamily: 'System-ui',
            color: 'var(--clr-theme-purple)',
          }}
        >
          mindly
        </Typography>
      )}
    </Box>
  );
});

export default LeftPanelHeader; 